export default __webpack_public_path__ + "static/media/sidecalltoaction-2.9e264c34.png";